import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { ICriteriaGroup } from "../../../types/criteriaGroup";
import { IQuestion } from "../../../types/question";

import { Icons } from '../../../data/Assets';

import { SVGIcon } from '../../wrappers/SVGIcon';

const SideBar = ({
  criteriaGroups,
  setCriteriaGroups,
  currOption,
  setCurrOption,
  questions,
}: {
  criteriaGroups: ICriteriaGroup[];
  setCriteriaGroups: React.Dispatch<React.SetStateAction<ICriteriaGroup[]>>;
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  questions: IQuestion[];
}) => {

  const params = useParams();

  const [showNewCriteriaGroup, setShowNewCriteriaGroup] =
    useState<boolean>(false);

  const [treeStack, setTreeStack] = useState<
    { criteria_group: number; criteria: number; criteria_details: number }[]
  >([]);

  const [showCriteriaGroup, setShowCriteriaGroup] = useState<Set<number>>(
    new Set()
  );
  const [showCriteria, setShowCriteria] = useState<
    { criteria_group: number; criteria: number }[]
  >([]);
  const [showNewCriteria, setShowNewCriteria] = useState<boolean>(false);
  const [showNewCriteriaDetails, setShowNewCriteriaDetails] =
    useState<boolean>(false);
  //   const { mutate: reorderSection } = useReorderSection();
  //   const { mutate: reorderPage } = useReorderPage();
  //   const { mutate: reorderQuestion } = useReorderQuestion();

  const isSelect = (checkArr: number[]) => {
    if (checkArr.length !== currOption.length) return "";

    for (let i = 0; i < checkArr.length; i++) {
      if (checkArr[i] !== currOption[i]) return "";
    }
    return "selected";
  };

  const expandorContractCriteriaGroup = (i: number) => {
    setCurrOption([i]);

    const hasCriteriaGroup = treeStack.filter(
      (stack) => stack.criteria_group === i
    ).length;
    if (hasCriteriaGroup) {
      setTreeStack((prev) =>
        prev.filter((stack) => stack.criteria_group !== i)
      );
      const delCriteriaGroup = showCriteriaGroup;
      delCriteriaGroup.delete(i);
      setShowCriteriaGroup(delCriteriaGroup);
    } else {
      const oldCriteriaGroup = [...showCriteriaGroup, i];
      setShowCriteriaGroup(new Set([...oldCriteriaGroup]));
      setTreeStack([
        ...treeStack,
        { criteria_group: i, criteria: -1, criteria_details: -1 },
      ]);
    }
  };

  const expandorContractCriteria = (i: number, j: number) => {
    setCurrOption([i, j]);

    const hasCriteria = treeStack.filter(
      (stack) => stack.criteria_group === i && stack.criteria === j
    ).length;

    console.log("hasCriteria", hasCriteria);

    if (hasCriteria) {
      setTreeStack((prev) =>
        prev.filter(
          (stack) => !(stack.criteria_group === i && stack.criteria === j)
        )
      );
      setShowCriteria((prev) =>
        prev.filter(
          (criteria) =>
            !(criteria.criteria_group === i && criteria.criteria === j)
        )
      );
    } else {
      setShowCriteria([...showCriteria, { criteria_group: i, criteria: j }]);
      setTreeStack([
        ...treeStack,
        { criteria_group: i, criteria: j, criteria_details: -1 },
      ]);
    }
  };

  const isCriteriaExpand = (crit_grp: number, crit: number) => {
    const expandCriteria =
      showCriteria.filter(
        (criteria) =>
          criteria.criteria_group === crit_grp && criteria.criteria === crit
      ).length !== 0;
    return expandCriteria;
  };

  const resetStack = () => {
    setCurrOption([criteriaGroups.length]);
    setTreeStack([]);
    setShowCriteriaGroup(new Set());
    setShowCriteria([]);
  };

  useEffect(() => {
    if (params.questcode) {
      setTreeStack([]);
      setShowCriteriaGroup(new Set());
      setShowCriteria([]);
    }
  }, [params.questcode]);

  useEffect(() => {
    if (currOption[0] === criteriaGroups.length) {
      setShowNewCriteriaGroup(true);
    } else {
      setShowNewCriteriaGroup(false);
    }

    if (currOption[1] === criteriaGroups[currOption[0]]?.criterias.length) {
      setShowNewCriteria(true);
    } else {
      setShowNewCriteria(false);
    }

    if (
      currOption.length > 2 &&
      currOption[2] ===
      criteriaGroups[currOption[0]]?.criterias[currOption[1]]
        ?.criteria_details.length
    ) {
      setShowNewCriteriaDetails(true);
    } else {
      setShowNewCriteriaDetails(false);
    }
  }, [currOption[0], currOption[1], currOption[2], criteriaGroups]); //eslint-disable-line

  useEffect(() => {
    setShowNewCriteriaGroup(false);
  }, [criteriaGroups.length]); //eslint-disable-line

  const criteriaLen = criteriaGroups[currOption[0]]?.criterias.length || 0;
  useEffect(() => {
    setShowNewCriteria(false);
  }, [criteriaLen]);

  const criteriaDetailsLen =
    criteriaGroups[currOption[0]]?.criterias[currOption[1]]?.criteria_details
      .length || 0;
  useEffect(() => {
    setShowNewCriteriaDetails(false);
  }, [criteriaDetailsLen]);

  const handleCreateCriteriaGroupNav = () => {
    resetStack();
    setShowNewCriteriaGroup(true);
  };

  const handleCreateCriteriaNav = (criteriaGroupId: number) => {
    setCurrOption([
      criteriaGroupId,
      criteriaGroups[criteriaGroupId].criterias.length,
    ]);
    setShowNewCriteria(true);
  };

  const handleCreateCriteriaDetailNav = (
    criteriaGroupId: number,
    criteriaId: number
  ) => {
    setCurrOption([
      criteriaGroupId,
      criteriaId,
      criteriaGroups[criteriaGroupId].criterias[criteriaId].criteria_details
        .length,
    ]);
    setShowNewCriteriaDetails(true);
  };

  //   const swapPosSection = (x: number, y: number) => {
  //     reorderSection({ id: sections[x].id, action: x === y - 1 ? "down" : "up" });
  //     const newArr = sections;
  //     const temp = newArr[x];
  //     newArr[x] = newArr[y];
  //     newArr[y] = temp;
  //     setCurrOption([y]);
  //     setSections([...newArr]);
  //   };

  //   const moveSectionUp = () => {
  //     if (currOption[0] === 0) {
  //       // do not move up
  //       console.log("Cannot move up!");
  //     } else {
  //       resetStack();
  //       swapPosSection(currOption[0], currOption[0] - 1);
  //     }
  //   };

  //   const moveSectionDown = () => {
  //     if (currOption[0] === sections.length - 1) {
  //       // do not move down
  //       console.log("Cannot move down!");
  //     } else {
  //       resetStack();
  //       swapPosSection(currOption[0], currOption[0] + 1);
  //     }
  //   };

  //   const swapPosPage = (x: number, y: number) => {
  //     reorderPage({
  //       id: sections[currOption[0]].pages[x].id,
  //       action: x === y - 1 ? "down" : "up",
  //     });
  //     const newArr = sections;
  //     const temp = sections[currOption[0]].pages[x];
  //     newArr[currOption[0]].pages[x] = newArr[currOption[0]].pages[y];
  //     newArr[currOption[0]].pages[y] = temp;

  //     setSections([...newArr]);
  //     setCurrOption([currOption[0], y]);
  //   };

  //   const movePageUp = () => {
  //     if (currOption[1] === 0) {
  //       // do not move up
  //       console.log("Cannot move up!");
  //     } else {
  //       setShowPage([]);
  //       swapPosPage(currOption[1], currOption[1] - 1);
  //     }
  //   };

  //   const movePageDown = () => {
  //     if (currOption[1] === sections[currOption[0]].pages.length - 1) {
  //       // do not move down
  //       console.log("Cannot move down!");
  //     } else {
  //       setShowPage([]);
  //       swapPosPage(currOption[1], currOption[1] + 1);
  //     }
  //   };

  //   const swapPosQuestion = (x: number, y: number) => {
  //     reorderQuestion({
  //       id: sections[currOption[0]].pages[currOption[1]].questions[x].id,
  //       action: x === y - 1 ? "down" : "up",
  //     });
  //     const newArr = sections;
  //     const temp = sections[currOption[0]].pages[currOption[1]].questions[x];
  //     newArr[currOption[0]].pages[currOption[1]].questions[x] =
  //       newArr[currOption[0]].pages[currOption[1]].questions[y];
  //     newArr[currOption[0]].pages[currOption[1]].questions[y] = temp;

  //     setSections([...newArr]);
  //     setCurrOption([currOption[0], currOption[1], y]);
  //   };

  //   const moveQuestionUp = () => {
  //     if (currOption[2] === 0) {
  //       // do not move up
  //       console.log("Cannot move up!");
  //     } else {
  //       swapPosQuestion(currOption[2], currOption[2] - 1);
  //     }
  //   };

  //   const moveQuestionDown = () => {
  //     if (
  //       currOption[2] ===
  //       sections[currOption[0]].pages[currOption[1]].questions.length - 1
  //     ) {
  //       // do not move down
  //       console.log("Cannot move down!");
  //     } else {
  //       swapPosQuestion(currOption[2], currOption[2] + 1);
  //     }
  //   };

  //   const movingUpButtonsDisableCondition = () => {
  //     if (currOption.length === 1) {
  //       return currOption[0] === sections.length || currOption[0] === 0;
  //     } else if (currOption.length === 2) {
  //       return (
  //         currOption[1] === sections[currOption[0]].pages.length ||
  //         currOption[1] === 0
  //       );
  //     } else if (currOption.length === 3) {
  //       return (
  //         currOption[2] ===
  //           sections[currOption[0]].pages[currOption[1]].questions.length ||
  //         currOption[2] === 0
  //       );
  //     }
  //   };

  //   const movingDownButtonsDisableCondition = () => {
  //     if (currOption.length === 1) {
  //       return currOption[0] >= sections.length - 1;
  //     } else if (currOption.length === 2) {
  //       return currOption[1] >= sections[currOption[0]].pages.length - 1;
  //     } else if (currOption.length === 3) {
  //       return (
  //         currOption[2] >=
  //         sections[currOption[0]].pages[currOption[1]].questions.length - 1
  //       );
  //     }
  //   };

  return (
    <div className="side_bar">
      <div className="options">
        <button
          disabled={
            showNewCriteriaGroup || showNewCriteria || showNewCriteriaDetails
          }
          onClick={handleCreateCriteriaGroupNav}
        >
          <SVGIcon src={Icons.Plus} />
          Group
        </button>
        <button
          onClick={() => handleCreateCriteriaNav(currOption[0])}
          disabled={
            showNewCriteriaGroup ||
            showNewCriteria ||
            showNewCriteriaDetails ||
            currOption.length < 1 ||
            criteriaGroups.length === 0
          }
        >
          <SVGIcon src={Icons.Plus} />
          Criteria
        </button>
        <button
          onClick={() =>
            handleCreateCriteriaDetailNav(currOption[0], currOption[1])
          }
          disabled={
            showNewCriteriaGroup ||
            showNewCriteria ||
            showNewCriteriaDetails ||
            currOption.length < 2
          }
        >
          <SVGIcon src={Icons.Plus} />
          Details
        </button>
      </div>

      <div className="options_tree">
        {(showNewCriteriaGroup || criteriaGroups.length === 0) && (
          <div
            id="new_section"
            className={`section cont selected`}
            onClick={() => setCurrOption([criteriaGroups.length])}
          >
            <SVGIcon src={Icons.PointFill} /> <p>New criteria group</p>
          </div>
        )}
        {criteriaGroups.map((criteriaGroup, i) => (
          <div key={i}>
            <div
              className={`section cont ${isSelect([i])} ${showCriteriaGroup.has(i) ? "rotate_svg" : ""
                }`}
              onClick={() => expandorContractCriteriaGroup(i)}
            >
              <SVGIcon src={Icons.TriangleFill} /> <p>{criteriaGroup.title}</p>
            </div>
            {showNewCriteria && currOption[0] === i && (
              <div
                id="new_page"
                className={`page cont selected`}
                onClick={() =>
                  setCurrOption([i, criteriaGroups[i].criterias.length])
                }
              >
                <SVGIcon src={Icons.PointFill} /> <p>New Criteria</p>
              </div>
            )}
            {(showCriteriaGroup.has(i) || (showNewCriteria && currOption[0] === i)) &&
              criteriaGroup.criterias.map((criteria, j) => (
                <div key={j}>
                  <div
                    className={`page cont ${isSelect([i, j])} ${isCriteriaExpand(i, j) ? "rotate_svg" : ""
                      }`}
                    onClick={() => expandorContractCriteria(i, j)}
                  >
                    <SVGIcon src={Icons.TriangleFill} />
                    <p>{criteria.method ? `[${criteria.method}]` : `[and]`}  {criteria.description}</p>
                  </div>
                  {showNewCriteriaDetails &&
                    currOption[0] === i &&
                    currOption[1] === j && (
                      <div
                        className={`question cont selected`}
                        onClick={() =>
                          setCurrOption([
                            i,
                            j,
                            criteriaGroups[i].criterias[j].criteria_details
                              .length,
                          ])
                        }
                      >
                        <p>New criteria detail</p>
                      </div>
                    )}
                  {(isCriteriaExpand(i, j) || (showNewCriteriaDetails && currOption[0] === i && currOption[1] === j)) &&
                    criteria.criteria_details.map(({ question_id }, k) => {
                      const questionName = questions.find(
                        (question) => question.id === question_id
                      )?.question;

                      return (
                        <div
                          key={k}
                          className={`question cont ${isSelect([i, j, k])}`}
                          onClick={() => setCurrOption([i, j, k])}
                        >
                          {questionName ? (
                            <p>{questionName}</p>
                          ) : (
                            <p>Question</p>
                          )}
                        </div>
                      );
                    })}
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SideBar;
